import { useEffect, useState } from "react";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg, mediaUrl } from "@/lib/api";
import { VisibilityIcon, VisibilityPicker } from "./VisibilityIcon";
import { NameChips } from "./NameChips";

export const AddToAlbumDialog = ({ ids, space, onClose, onDone }) => {
  const [albums, setAlbums] = useState(null);
  const [name, setName] = useState("");
  const [vis, setVis] = useState("private");

  useEffect(() => {
    if (ids) api.get("/albums", { params: { space, kind: "regular", limit: 200 } }).then((r) => setAlbums(r.data.albums));
  }, [ids, space]);

  const addTo = async (album) => {
    try {
      const { data } = await api.post(`/albums/${album.id}/items`, { item_ids: ids });
      toast.success(`Added ${data.added} to “${album.name}”${data.rejected ? ` · ${data.rejected} not in this space` : ""}`);
      onDone?.();
      onClose();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const create = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    try {
      const { data } = await api.post("/albums", { name, space: space === "all" ? vis : space });
      await addTo(data);
    } catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <Dialog open={Boolean(ids)} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md bg-[#f4f3f0]" data-testid="add-to-album-dialog">
        <DialogHeader>
          <DialogTitle className="serif text-2xl">Add to album</DialogTitle>
          <DialogDescription>{ids?.length} item(s) · items can only join albums with the same visibility</DialogDescription>
        </DialogHeader>
        {space === "all" && <VisibilityPicker value={vis} onChange={setVis} testid="new-album-visibility" />}
        <form onSubmit={create} className="flex gap-2">
          <input className="login-input !mb-0 flex-1" placeholder="New album name" value={name} onChange={(e) => setName(e.target.value)} data-testid="new-album-name-input" />
          <button className="btn-ink !px-4" data-testid="new-album-create-button"><Plus size={16} /></button>
        </form>
        {ids && <NameChips itemIds={ids} onPick={setName} testid="add-album-name-chips" />}
        <ul className="max-h-72 overflow-y-auto divide-y divide-neutral-200">
          {albums?.map((a) => (
            <li key={a.id}>
              <button className="flex items-center gap-3 w-full py-2 text-left hover:bg-white/70 px-1 rounded" onClick={() => addTo(a)} data-testid={`add-to-album-option-${a.id}`}>
                <span className="w-10 h-12 bg-white shadow-sm flex items-center justify-center overflow-hidden">
                  {a.cover_url && <img src={mediaUrl(a.cover_url)} alt="" className="w-full h-full object-cover" />}
                </span>
                <span className="text-sm flex-1">{a.name}</span>
                <VisibilityIcon space={a.space} testid={`add-to-album-visibility-${a.id}`} />
              </button>
            </li>
          ))}
          {albums && !albums.length && <li className="text-sm text-neutral-500 py-3">No albums yet. Create one above.</li>}
        </ul>
      </DialogContent>
    </Dialog>
  );
};
